import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import ProfileCategoryDropdown from "./../../../Common/profilecategoryDropdown";
import ProfileFriendListDropdown from "./../../../Common/profilefriendlistDropdown";
import { getlanguagelist } from "../../../../helpers/changelanguage";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 45;
  const left = 45;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: '0',
    boxShadow: theme.shadows[12],
   
  },
}));

export default function AddmoreModal(props) {
  let  languagelist    = getlanguagelist();
  const classes         = useStyles();
  const [modalStyle]    = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const modalOpen       = props.modalOpen;
  const handleOpen = () => {
   // setOpen(true);
  };

  const handleClose = () => {
    props.handleClose();
  };
  const addMore = () => {
    props.addMore();
  }
  const changeAddmoreprivacy = () => {
    props.changeAddmoreprivacy(document.getElementById('addmodal_privacy').value);
  }

  return (
    <Modal
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
    open={modalOpen}
    onClose={handleClose}
    >
      <div style={modalStyle} className={`popup_list ${classes.paper}`} >
       
            <h4 className="popup_list-title">{`${languagelist.addnew} ${props.addmoreTitle}`}   
              <span className="pull-right add-select">
                <select className="form-control" value={props.addmodal_privacy} name="addmodal_privacy" id="addmodal_privacy"  onChange={() => changeAddmoreprivacy()}>
                  <option value=""> {languagelist.selectprivacy} </option>
                  <option value="PUBLIC">{languagelist.public} </option>
                  <option value="ME">{languagelist.me}</option>
                  <option value="FRIENDS">{languagelist.pfriend}</option>
                </select>
              </span>
            </h4>
           
          <div className="clearfix"></div>
            <div className="popup_inner">
              {(props.addmoreTitle != 'Education') ? 
                <div className="popup_input">
                  <ProfileCategoryDropdown dataList={props.categoryList} changeHandeler={props.changeCategory} defaultVal={props.addmore_catname} addmoreTitle={props.addmoreTitle}></ProfileCategoryDropdown>
                </div>
              : null 
              }
              {((props.addmoreTitle == 'Education') || (props.addmoreTitle == 'Relationship') || (props.addmoreTitle == 'Social Status')) ? 
                <div className="popup_input">
                  <ProfileFriendListDropdown dataList={props.friendlist} changeHandeler={props.changeFriendDropdown} defaultVal={props.addmore_frndname} addmoreTitle={props.addmoreTitle}></ProfileFriendListDropdown>
                </div>
                : null 
              }
               
               
                <div className="text-center popup_btn">
                     <button className="btn_5" onClick={() => addMore()}> {languagelist.add} </button>
                </div>
                            
              {/* <button onClick={() => addMore()}>Add</button> */}
            </div>
            
      </div>
    </Modal>
     
  
  );
}
